import React from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { useHistory, useParams } from 'react-router-dom';

import { AppHeader, CircularLoader } from 'components';

import ConfirmContext from 'contexts/ConfirmContext';

import { getReceivedBookedActivityData } from 'utils/book-activity/prepareReceivedBookedActivityData';

import { ACTIVITY_BOOKING } from 'graphql/queries/activities-bookings';

import BookActivity from 'pages/book-activity/BookActivity';

import useStyles from './styles';

const UpdateActivityBookingWrapper = ({ businessOwner }) => {
  const classes = useStyles();
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data } = useQuery(ACTIVITY_BOOKING, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      activityBookingId: parseInt(id),
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  if (loading || !businessOwner.selectedBusinessOwner.hasOwnProperty('id')) {
    return (
      <>
        <AppHeader />

        <CircularLoader
          isLoading={true}
          loaderClassName={classes.loaderClassName}
          className={classes.loaderWrapper}
        />
      </>
    );
  }

  if (error || !data.activitiesBookings.length) {
    confirm({
      title: 'Activity booking does not exist!',
      confirmationText: 'Back'
    })
      .then(() => history.push('/booking-list'))
      .catch(() => {});

    return <div style={{ height: '100%' }}>{''}</div>;
  }

  const bookedData = loading
    ? null
    : getReceivedBookedActivityData(data.activitiesBookings[0]);

  return (
    <BookActivity
      initialValues={bookedData}
      bookedData={bookedData}
      isUpdate={true}
    />
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(UpdateActivityBookingWrapper);
